import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { UNSUBSCRIBED_CHANNELS, UNSUBSCRIBED_MESSAGE_TYPES } from 'utils/fieldConstants';
import {
  getEventFieldMappings,
  getIsFetchingEventFieldMappings,
  getIsJourneyFieldMappingsEnabled,
} from 'modules/workflows/ducks';
import { getESFieldDisplayName } from 'modules/workflows/utils';
import { useFieldMappingsContext } from 'modules/workflows/context/FieldMappingsContext';
import { BaseOption } from 'ui/selects';
import { GenericDataType } from 'modules/domains';

export const useFieldMappingOptions = ({
  dataType,
  isStartNode = false,
}: {
  dataType?: string;
  isStartNode: boolean;
}): [BaseOption[], boolean] => {
  const isJourneyFieldMappingsEnabled = useSelector(getIsJourneyFieldMappingsEnabled);
  const { fieldMappings, isLoading } = useFieldMappingsContext();
  const [fieldOptions, setFieldOptions] = useState<BaseOption[]>([]);

  const mappingsOld = useSelector(getEventFieldMappings);
  const mappings = isJourneyFieldMappingsEnabled ? fieldMappings : mappingsOld;

  const isFetchingOld = useSelector(getIsFetchingEventFieldMappings);
  const isLoadingMapping = isJourneyFieldMappingsEnabled ? isLoading : isFetchingOld;

  useEffect(() => {
    if (mappings?.user) {
      const parsedFields = Object.values(mappings.user)
        .map(({ fieldType, field: fieldValue }) => ({
          value: fieldValue,
          id: fieldValue,
          label: getESFieldDisplayName(fieldValue, dataType),
          Suffix: fieldType,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      setFieldOptions(parsedFields);
    }
  }, [mappings?.user]);

  // we do not want to show unsubscribedMessageTypeIds and unsubscribedChannelIds for user data type
  const filteredFieldOptions =
    dataType === GenericDataType.User && isStartNode
      ? fieldOptions.filter(
          (x) => ![UNSUBSCRIBED_MESSAGE_TYPES, UNSUBSCRIBED_CHANNELS].includes(x.id),
        )
      : fieldOptions;

  return [filteredFieldOptions, isLoadingMapping];
};
